"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSharingUrlContext = exports.SharingUrlProvider = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const libs_context_page_type_1 = require("@hotelplan/libs.context.page-type");
const SharingUrlContext = react_1.default.createContext({
    setUrl: noop_1.default,
    setUrlParams: noop_1.default,
    setSharingData: noop_1.default,
    reset: noop_1.default,
});
var ActionType;
(function (ActionType) {
    ActionType[ActionType["SET_URL"] = 0] = "SET_URL";
    ActionType[ActionType["SET_URL_PARAMS"] = 1] = "SET_URL_PARAMS";
    ActionType[ActionType["SET_DATA"] = 2] = "SET_DATA";
    ActionType[ActionType["RESET"] = 3] = "RESET";
})(ActionType || (ActionType = {}));
function reducer(prevState, action) {
    switch (action.type) {
        case ActionType.SET_URL: {
            return Object.assign(Object.assign({}, prevState), { url: action.url });
        }
        case ActionType.SET_URL_PARAMS: {
            return Object.assign(Object.assign({}, prevState), { urlParams: action.urlParams });
        }
        case ActionType.SET_DATA: {
            return Object.assign(Object.assign({}, prevState), action.data);
        }
        case ActionType.RESET: {
            return Object.assign(Object.assign({}, prevState), { url: undefined });
        }
    }
    return prevState;
}
const SharingUrlProvider = ({ children, }) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer, {});
    const contextValue = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, state), { setUrl(nextUrl) {
                dispatch({ type: ActionType.SET_URL, url: nextUrl });
            },
            setUrlParams(nextUrlParams) {
                dispatch({ type: ActionType.SET_URL_PARAMS, urlParams: nextUrlParams });
            },
            setSharingData(data) {
                dispatch({ type: ActionType.SET_DATA, data });
            },
            reset() {
                dispatch({ type: ActionType.RESET });
            } });
    }, [state]);
    const pageType = (0, libs_context_page_type_1.usePageType)();
    (0, react_1.useEffect)(() => {
        dispatch({ type: ActionType.RESET });
    }, [pageType]);
    return (react_1.default.createElement(SharingUrlContext.Provider, { value: contextValue }, children));
};
exports.SharingUrlProvider = SharingUrlProvider;
function useSharingUrlContext() {
    return (0, react_1.useContext)(SharingUrlContext);
}
exports.useSharingUrlContext = useSharingUrlContext;
//# sourceMappingURL=sharing-url-context.js.map